import StatusBar from '../StatusBar'
import StatusItem from '../StatusItem'
import { isFailed, isSuccess } from '../../helper'
import { StyledTradeStatus } from '../../styled'
import { TRADE_STATUS, TRADE_TYPE } from '../../types'
import { t } from 'i18next'

interface Props {
  status: TRADE_STATUS
  tradeType?: TRADE_TYPE
}

const successArr = [
  TRADE_STATUS.UN_BROADCAST,
  TRADE_STATUS.PENDING,
  TRADE_STATUS.SUCCESS,
]
const failedArr = [
  TRADE_STATUS.UN_BROADCAST,
  TRADE_STATUS.FAILED,
  TRADE_STATUS.SUCCESS,
]

const getStatusArr = (status: TRADE_STATUS) => {
  let activeIndex = 0
  let statusArr = successArr
  let failedStyle = ''
  if (isFailed(status)) {
    activeIndex = 1
    failedStyle = 'faild-status'
    statusArr = failedArr
  } else if (isSuccess(status)) {
    activeIndex = 2
  }
  return statusArr.map((status: TRADE_STATUS, index) => {
    return {
      status,
      isActive: activeIndex === index,
      isOver: activeIndex > index,
      failedStyle,
    }
  })
}

const OrderStatus: React.FC<Props> = ({
  status,
  tradeType = TRADE_TYPE.STAKING,
}) => {
  const statusArr = getStatusArr(status)
  const isInstant = tradeType === TRADE_TYPE.INSTANT
  const isPending = status === TRADE_STATUS.PENDING

  return (
    <StyledTradeStatus
      className={`trade-status-container ${isInstant && 'instant'}`}
    >
      <StatusBar status={status} tradeType={tradeType} />
      <div className={`status-area ${isInstant && 'instant'}`}>
        {statusArr.map((item, index) => {
          const { status, isActive, isOver, failedStyle } = item
          const activeStyle = isOver || isActive ? 'active-status' : ''
          const textStyle = failedStyle || activeStyle
          return (
            <StatusItem
              status={status}
              style={textStyle}
              key={index}
              tradeType={tradeType}
            />
          )
        })}
      </div>
      {isInstant && isPending && (
        <p className="status-tips">{t('instant_order_pending_tips')}</p>
      )}
    </StyledTradeStatus>
  )
}

export default OrderStatus
